<template></template>

<script>
import * as XLSX from "xlsx";

import whApi from "@/api/warehouse/";

import dayjs, { Dayjs } from "dayjs";

import numbro from "numbro";

export default {
  name: "app",
  props: {
    dataExportExcel: Object,
  },
  data() {
    return {
      jsonExport: [],

      mainProduct: [],
      subProduct: [],

      // loading: false
    };
  },

  async created() {
    await this.getAllMainPd();
    await this.getAllSubPd();
    await this.groupDateExport();
    // this.onExport();
  },

  methods: {
    groupDateExport() {
      let newMainPd = {};
      let newSubPd = {};

      this.dataExportExcel.forEach((element, index) => {
        newMainPd = this.mainProduct.find(
          (data) => data.id === element.product.mainProductGroupId
        );

        newSubPd = this.subProduct.find(
          (data) => data.id === element.product.subProductGroupId
        );

        !newMainPd
          ? ""
          : !newSubPd
          ? ""
          : this.jsonExport.push({
              "#": index + 1,
              รหัสสินค้า: element.product.product_code,
              ชื่อสินค้า: element.product.product_name,
              Barcode: element.product.product_barcode,
              กลุ่มสินค้าหลัก: newMainPd.main_product_group_name,
              กลุ่มสินค้ารอง: newSubPd.sub_product_group_name,
              POG: element.product.product_pog,
              ราคาปลีก: numbro(element.product.product_retail_price).format({
                thousandSeparated: true,
                mantissa: 2,
              }),
              "Expire Code": element.expire_no,
              วันหมดอายุ: element.expire_date,
            });
      });

      this.onExport();
    },

    async getAllMainPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.mainProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.mainProduct = responseData.data;
        // this.loading = false;
      }
    },

    async getAllSubPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.subProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.subProduct = responseData.data;
        // this.loading = false;
      }
    },

    onExport() {
      const date = dayjs(new Date()).format("YYYY-MM-DD-HHMM");

      const dataWS = XLSX.utils.json_to_sheet(this.jsonExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS, "ProductExpire1", true);
      XLSX.writeFile(wb, `ProductExpire-${date}.xlsx`);
    },
  },
};
</script>
